import { render, staticRenderFns } from "./DepositOrderDescription.vue?vue&type=template&id=2db1679d&scoped=true"
import script from "./DepositOrderDescription.vue?vue&type=script&lang=js"
export * from "./DepositOrderDescription.vue?vue&type=script&lang=js"
import style0 from "./DepositOrderDescription.vue?vue&type=style&index=0&id=2db1679d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@0.28.11_lodash@4.17.21_vue-t_erapicvfwevmkf5xbebrw2tmey/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1679d",
  null
  
)

export default component.exports